import { render, staticRenderFns } from "./widthTitle2.vue?vue&type=template&id=2829a87c&scoped=true"
import script from "./widthTitle2.vue?vue&type=script&lang=js"
export * from "./widthTitle2.vue?vue&type=script&lang=js"
import style0 from "./widthTitle2.vue?vue&type=style&index=0&id=2829a87c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2829a87c",
  null
  
)

export default component.exports